import { render, staticRenderFns } from "./integralRuleSet.vue?vue&type=template&id=50fc4cc3&scoped=true&"
import script from "./integralRuleSet.vue?vue&type=script&lang=js&"
export * from "./integralRuleSet.vue?vue&type=script&lang=js&"
import style0 from "./integralRuleSet.vue?vue&type=style&index=0&id=50fc4cc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc4cc3",
  null
  
)

export default component.exports